import React, {Component} from 'react';
import queryString from 'query-string';
import Axios from 'axios';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Swal from 'sweetalert2';
import Configs from '../../../Configs';
import Spinner from '../../../components/UI/Spinner/Spinner';
import moment from 'moment';
import Parse from '../../../Parse';
import NoData from '../../../components/UI/Spinner/NoData';
import Filter from '../../../helpers/Filter';
import './Transactions.css';

const ranges = {
    'Today': [moment(), moment()],
    'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
}

const options = {
    page: 1,
    sizePerPageList: [ 
        {
            text: '15', value: 15
        }, 
        {
            text: '25', value: 25
        }, 
        {
            text: '50', value: 50
        } 
    ],
    sizePerPage: 15,
    pageStartIndex: 1,
    paginationSize: 1,
    prePage: 'Prev',
    nextPage: 'Next',
    firstPage: 'First',
    lastPage: 'Last',
    paginationPosition: 'bottom'
};

const Status = [
    "Confirming",
    "Preparing",
    "Cooking",
    "Cooked",
    "Delivering",
    "Delivered",
    "Billed",
    "Paid",
    "Cancelled",
    "Refund"
];

function dateFormatter(cell, row) {
    return (
        `<p>${moment(cell).format('LLL')}</p>`
    );
}

function statusFormatter(cell, row) {
    return (
        `<p>${Status[cell] !== undefined ? Status[cell] : "" }</p>`
    );
}

function currencyFormatter(cell) {
    return (
        <b>
            {Filter.displayCurrency(cell)}
        </b>
    )
}

class Transactions extends Component {
    state = {
        loading: false,
        loadingOrder: false,
        transactions: [],
        transaction: {},
        fromDate: null,
        toDate: null,
        last_id: 0,
        pagination_id: "",
        page: 1,
        openPopup: false,
        orders: [],
        totalOrders: []
    };

    getCoupon = (comment, coupon) => {
        if(coupon === undefined) {
            return comment;
        }
        let commentWorking = comment;
        if(comment !== "") {
            commentWorking = commentWorking + "<br>";
        }
        const complementaryBy = JSON.parse(coupon);			
        return commentWorking + ' Complimentary by ' + complementaryBy.user;
    }

    getShift = (comment, shift) => {
        if(shift === undefined) {
            return comment;
        }
        let commentWorking = comment;
        if(comment !== "") {
            commentWorking = commentWorking + "<br>";
        }
        const shiftJson = JSON.parse(shift);		
        const shiftId = shiftJson.index !== undefined ? shiftJson.index : 0;
        return commentWorking + "Shift #" + shiftId;
    }

    getOrderOrg = (comment, orderOrg) => {
        if(orderOrg === undefined) {
            return comment;
        }
        let commentWorking = comment;
        if(comment !== "") {
            commentWorking = commentWorking + "<br>";
        }
        const orderOrgJson = JSON.parse(orderOrg);
        let orderOrgID = "";
        for(var q = 0; q < orderOrgJson.length; q++){
            if(orderOrgID !== ""){ 
                orderOrgID = orderOrgID + ", ";	
            }
            orderOrgID = orderOrgID + orderOrgJson[q];
        }		
        return commentWorking + "Original Order No: " + orderOrgID;
    }

    getReOpen = (comment, reopen) => {
        if(reopen === undefined) {
            return comment;
        }
        let commentWorking = comment;
        if(comment !== "") {
            commentWorking = commentWorking + "<br>";
        }
        const reopenJson = JSON.parse(reopen);
        let reopenStringText = "";
        let reopenStringList = [];
        
        for(var w = 0; w < reopenJson.length; w++){
            reopenStringList = reopenJson[w];
            if(reopenStringText != ""){ 
                reopenStringText = reopenStringText + ", ";	
            }
            let time = new Date(reopenStringList['modify']);
            reopenStringText = reopenStringText + reopenStringList['user'] + " (" + moment(time).format("DD MM YYYY HH:ss") + ")";
        }		
	
	    return commentWorking + "Reopen: " + reopenStringText;
    }

    componentDidMount() {
        this.getTransactions();
    }

    getOrder = (orderId, transaction) => {
        const queries = queryString.parse(this.props.location.search)
        console.log("queries", queries);
        if(queries.controller == undefined || !queries.controller) {
            Swal.fire(`No Exist Controller information`);    
            return
        }
        this.setState({
            loadingOrder: true
        })
        Parse.Cloud.run("commons", {
            classes: "order",
            limit: 100,
            order: {},
            page: 1,
            queries: [
                {
                    param: "controller",
                    value: queries.controller,
                    where: "equals",
                },
                {
                    param: "order",
                    value: orderId,
                    where: "equals"
                }
            ]
        })
        .then((res) => {
            this.setState({
                loadingOrder: false
            })
            if(!res) {
                Swal.fire(`No Order information`);    
                return
            }
            if(res.data == undefined || !res.data) {
                Swal.fire(`No Exist Order information`);    
                return
            }
            const newResults = res.data.map(value => {
                const price = +value.prices_value;
                const quantity = +value.qty;
                const message = value.comment;
                const coupon = value.coupon;
                const shift = value.shift;
                const orderOrg = value.order_org;
                const reopen = value.reopen;

                let comment = "";
                comment = message !== undefined ? comment + message : comment;

                comment = this.getCoupon(comment, coupon);
                comment = this.getShift(comment, shift);
                comment = this.getOrderOrg(comment, orderOrg);
                comment = this.getReOpen(comment, reopen);

                const paidAmount = value.cash_payments;
                const actualTotal = value.paid_amount;
                const changeAmount = actualTotal - paidAmount;

                return {
                    id: value.id,
                    order: value.order,
                    create: value.create,
                    modify: value.modify,
                    dish_name: value.dish_name,
                    status: value.status,
                    prices_name: value.prices_name,
                    prices_value: value.prices_value,
                    qty: value.qty,
                    total: price * quantity,
                    table: value.table,
                    user: value.user,
                    agent_code: value.agent_code,
                    paid_sub_total: value.paid_sub_total,
                    paid_tax_before: value.paid_tax_before,
                    taxBefore: value.taxBefore,
                    discount: value.discount,
                    paid_discount: value.paid_discount,
                    tax1_name: value.tax1_name,
                    tax1: value.tax1,
                    paid_tax1: value.paid_tax1,
                    tax2_name: value.tax2_name,
                    tax2: value.tax2,
                    paid_tax2: value.paid_tax2,
                    paid_total: value.paid_total,
                    cash_payments: value.cash_payments,
                    paid_type: value.paid_type,
                    paid_amount: value.paid_amount,
                    special_note: "",
                    change_amount: changeAmount,
                    comment: comment
                }
            })

            let totalOrders = [];
            if(newResults.length > 0) {
                totalOrders = [newResults.slice(-1).pop()]
            }

            this.setState({
                loadingOrder: false,
                orders: newResults,
                transaction: transaction,
                totalOrders: totalOrders
            })
        })
        .catch((err) => {
            this.setState({
                loadingOrder: false
            })
            Swal.fire(`Error when get Order information`);
        })
    }

    getTransactions = () => {
        this.setState({
            loading: true
        })
        const clientid = this.props.match.params.clientId;
        Axios.post(`${Configs.eberUrl}`, {
            path: `point_transaction`,
            method: "GET",
            data: {
                limit: 20,
                // last_id: this.state.last_id,
                pagination_id: this.state.pagination_id,
                page: this.state.page,
                ...(this.state.fromDate && this.state.toDate ? {
                    from_date: this.state.fromDate.format("YYYY-MM-DD"),
                    to_date: this.state.toDate.format("YYYY-MM-DD")
                }: {})
            }
        }, {
            headers: { 
                'Authorization': `Basic ${clientid}`,
                'Content-Type': 'application/json'
            }
        }).then(res => {
            this.setState({
                loading: false
            })
            const data = {
                ...res.data.data
            }
            const pagination = {
                ...res.data.paging
            }
            let last_id = this.state.last_id;
            if(pagination.last_id !== 0) {
                last_id = pagination.last_id
            }
            this.setState({
                transactions: [...Object.values(data)],
                last_id: last_id,
                pagination_id: pagination.pagination_id
            })
        }).catch(err => {
            this.setState({
                loading: false
            })
            Swal.fire({
                title: "Error when get Transaction"
            });
        });
    }

    prevPage = () => {
        let page = this.state.page;
        if(page === 1) {
            return;
        }
        page = page - 1;
        this.setState({
            page: page
        }, () => {
            this.getTransactions();
        })
    }

    nextPage = () => {
        let page = this.state.page;
        page = page + 1;
        this.setState({
            page: page
        }, () => {
            this.getTransactions();
        })
    }

    changeDateHandler = (picker) => {
        const start = picker.startDate;
        const end = picker.endDate;
        this.setState({
            fromDate: start,
            toDate: end
        }, () => {
            this.getTransactions();
        })
    }

    render() {
        if(this.state.loading) {
            return (
                <React.Fragment>
                    <div className="col-xs-12 col-md-12 col-lg-12">
                        <div className="row text-center">
                            <div className="col-md-12 col-xs-12 col-lg-12">
                                <Spinner></Spinner>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        const transactions = [...this.state.transactions];
        const transactionDetail = {...this.state.transaction};
        
        let storeName = null;
        let couponName = null;
        let couponStatus = null;
        let displayName = null;
        if(
            transactionDetail.store !== undefined && 
            transactionDetail.store
        ) {
            storeName = transactionDetail.store.name !== undefined && transactionDetail.store.name ? transactionDetail.store.name : null;
        }
        if(transactionDetail.coupon_issued !== undefined && transactionDetail.coupon_issued) {
            if(
                transactionDetail.coupon_issued.main_coupon !== undefined && 
                transactionDetail.coupon_issued.main_coupon && 
                transactionDetail.coupon_issued.main_coupon.name !== undefined
            ) {
                couponName = transactionDetail.coupon_issued.main_coupon.name
            }
            if(transactionDetail.coupon_issued.status !== undefined) {
                couponStatus = transactionDetail.coupon_issued.status
            }
        }
        if(transactionDetail.user !== undefined && transactionDetail.user) {
            if(
                transactionDetail.user.display_name !== undefined && 
                transactionDetail.user.display_name
            ) {
                displayName = transactionDetail.user.display_name
            }
        }
        const orders = [...this.state.orders];
        const totalOrders = [...this.state.totalOrders];
        let start = moment();
        let end = moment();
        if(this.state.fromDate && this.state.toDate) {
            start = this.state.fromDate;
            end = this.state.toDate;
        }
        return (
            <React.Fragment>
                <div className="col-md-9 col-xs-12 col-lg-9 outletDatePicker">
                    <DateRangePicker startDate={start} endDate={end} ranges={ranges} onApply={(e, picker) => {
                            return this.changeDateHandler(picker);
                        }}>
                        {
                            start !== undefined && end !== undefined && start && end ? (
                                <div className="detailDateRage">
                                    <i className="fa fa-calendar"></i>&nbsp;
                                    <span>{start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY')}</span> <i className="fa fa-caret-down"></i>
                                </div>
                            ) : (
                                <div className="detailDateRage">
                                    <i className="fa fa-calendar"></i>&nbsp;
                                    <span>No Choose Date</span> <i className="fa fa-caret-down"></i>
                                </div>
                            )
                        }
                    </DateRangePicker>
                    <br></br>
                    <br></br>
                </div>  
                <div className="col-xs-12 col-md-12 col-lg-12 table-responsive no-padding">
                    <table className="table table-hover reportTable">
                        <tbody>
                            <tr>
                                <th>Store</th>
                                <th>Type</th>
                                <th>FoodZaps Receipt No</th>
                                <th>Point</th>
                                <th>User</th>
                                <th>Coupon</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th></th>
                            </tr>
                            {
                                transactions.map((transaction, key) => {
                                    let storeName = null;
                                    let couponName = null;
                                    let couponStatus = null;
                                    if(
                                        transaction.store !== undefined && 
                                        transaction.store
                                    ) {
                                        storeName = transaction.store.name !== undefined && transaction.store.name ? transaction.store.name : null;
                                    }
                                    if(transaction.coupon_issued !== undefined && transaction.coupon_issued) {
                                        if(
                                            transaction.coupon_issued.main_coupon !== undefined && 
                                            transaction.coupon_issued.main_coupon && 
                                            transaction.coupon_issued.main_coupon.name !== undefined
                                        ) {
                                            couponName = transaction.coupon_issued.main_coupon.name
                                        }
                                        if(transaction.coupon_issued.status !== undefined) {
                                            couponStatus = transaction.coupon_issued.status
                                        }
                                    }
                                    return (
                                        <tr key={key}>
                                            <td>{storeName}</td>
                                            <td>{transaction.type}</td>
                                            <td>{transaction.transaction_no}</td>
                                            <td>{transaction.points}</td>
                                            <td>{transaction.user.display_name}</td>
                                            <td>{couponName}</td>
                                            <td>{couponStatus}</td>
                                            <td>{moment(transaction.created_at).format("DD-MM-YYYY")}</td>
                                            <td>
                                                <button className="btn btn-sm btn-default" onClick={() => {
                                                    this.setState({
                                                        openPopup: true
                                                    }, () => {
                                                        this.getOrder(transaction.transaction_no, transaction)
                                                    })
                                                }}>View Order</button>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>    
                </div>
                <div className="col-xs-12 col-md-12 col-lg-12 no-padding">
                    <div class="btn-group">
                        <button type="button" className="btn btn-default" onClick={() => this.prevPage()}>Previous</button>
                        <button type="button" className="btn btn-default" onClick={() => this.nextPage()}>Next</button>
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                </div>
                {
                    this.state.openPopup ? (
                        <div className="MoreButtonPopup EberTransaction">
                            <div className="popup_image_bover">
                            </div>
                            <div className="popup_image form-popup">
                                <div className="form-container">
                                    <div className="popup_header">
                                        <h3 className="pull-left">Transaction View</h3>
                                    </div>
                                    <div className="popup_body">
                                        {!this.state.loading ? (
                                            <div>
                                                <div className="col-md-12 col-lg-12 col-xs-12">
                                                    {
                                                        transactionDetail !== undefined && transactionDetail ? (
                                                            <React.Fragment>
                                                                <p><b>Store Name: </b>{storeName}</p>
                                                                <p><b>Type: </b>{transactionDetail.type}</p>
                                                                <p><b>FoodZaps Receipt No: </b>{transactionDetail.transaction_no}</p>
                                                                <p><b>Point: </b>{transactionDetail.points}</p>
                                                                <p><b>User Name: </b>{displayName}</p>
                                                                <p><b>Coupon: </b>{couponName}</p>
                                                                <p><b>Status: </b>{couponStatus}</p>
                                                                <p><b>Date: </b>{moment(transactionDetail.created_at).format("DD-MM-YYYY")}</p>
                                                            </React.Fragment>
                                                        ) : null
                                                    }
                                                </div>
                                                <div className="col-md-12 col-lg-12 col-xs-12">
                                                {
                                                    orders.length > 0 ? (
                                                        <BootstrapTable data={ orders } options={options} pagination={ true }>
                                                            <TableHeaderColumn width='100' dataField='order' isKey={true} dataSort={true}>Order No</TableHeaderColumn>
                                                            <TableHeaderColumn width='200' dataField='create' dataFormat={dateFormatter} dataSort={true}>Create</TableHeaderColumn>
                                                            <TableHeaderColumn width='200' dataField='modify' dataFormat={dateFormatter} dataSort={true}>Modify</TableHeaderColumn>
                                                            <TableHeaderColumn width='250' dataField='dish_name' dataSort={true}>Name of Dish</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='status' dataFormat={statusFormatter} dataSort={true}>Status</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='prices_name' dataSort={true}>Price Name</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='prices_value' dataFormat={currencyFormatter} dataSort={true}>Price</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='qty' dataSort={true}>Quantity</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='total' dataFormat={currencyFormatter} dataSort={true}>Total</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='table' dataSort={true}>Table No</TableHeaderColumn>
                                                            <TableHeaderColumn width='200' dataField='user' dataSort={true}>Waiter</TableHeaderColumn>
                                                            <TableHeaderColumn width='100' dataField='agent_code' dataSort={true}>Agent</TableHeaderColumn>
                                                            <TableHeaderColumn width='200' dataField='comment' dataSort={true}>Comment</TableHeaderColumn>
                                                        </BootstrapTable>
                                                    ) : <NoData></NoData>
                                                }  
                                                </div>
                                                <hr></hr>
                                                <div className="col-md-12 col-lg-12 col-xs-12">
                                                    {
                                                        totalOrders.length > 0 ? (
                                                            <BootstrapTable data={ totalOrders } options={options} pagination={ true }>
                                                                <TableHeaderColumn width='100' dataField='order' isKey={true} dataSort={true}>Order No</TableHeaderColumn>
                                                                <TableHeaderColumn width='100' dataField='paid_sub_total' dataFormat={currencyFormatter} dataSort={true}>Sub Total</TableHeaderColumn>
                                                                {
                                                                    totalOrders[0].discount !== undefined && totalOrders[0].discount > 0 ? (
                                                                        <TableHeaderColumn width='100' dataField='paid_discount' dataFormat={currencyFormatter} dataSort={true}>Discount ({totalOrders[0].discount} %)</TableHeaderColumn>
                                                                    ) : null
                                                                }
                                                                {
                                                                    totalOrders[0].tax1_name !== undefined && totalOrders[0].tax1_name ? (
                                                                        <TableHeaderColumn width='100' dataField='paid_tax1' dataFormat={currencyFormatter} dataSort={true}>{`${totalOrders[0].tax1_name} (${totalOrders[0].tax1 < 0 ? -1 * totalOrders[0].tax1 : totalOrders[0].tax1} %)`}</TableHeaderColumn>
                                                                    ) : null
                                                                }
                                                                {
                                                                    totalOrders[0].tax2_name !== undefined && totalOrders[0].tax2_name ? (
                                                                        <TableHeaderColumn width='100' dataField='paid_tax1' dataFormat={currencyFormatter} dataSort={true}>{`${totalOrders[0].tax2_name} (${totalOrders[0].tax2 < 0 ? -1 * totalOrders[0].tax2 : totalOrders[0].tax2} %)`}</TableHeaderColumn>
                                                                    ) : null
                                                                }
                                                                <TableHeaderColumn width='100' dataField='paid_total' dataSort={true}>Total</TableHeaderColumn>
                                                                <TableHeaderColumn width='100' dataField='cash_payments' dataFormat={currencyFormatter} dataSort={true}>Payable</TableHeaderColumn>
                                                                {
                                                                    totalOrders[0].paid_type !== undefined && totalOrders[0].paid_type ? (
                                                                        <TableHeaderColumn width='100' dataField='paid_amount' dataFormat={currencyFormatter} dataSort={true}>{totalOrders[0].paid_type}</TableHeaderColumn>
                                                                    ) : (
                                                                        null
                                                                    )
                                                                }
                                                                <TableHeaderColumn width='100' dataField='change_amount' dataFormat={currencyFormatter} dataSort={true}>Change</TableHeaderColumn>
                                                                <TableHeaderColumn width='100' dataField='agent_code' dataSort={true}>Agent</TableHeaderColumn>
                                                                <TableHeaderColumn width='200' dataField='special_note' dataSort={true}>Payment</TableHeaderColumn>
                                                            </BootstrapTable>
                                                        ) : null
                                                    }
                                                </div>      
                                            </div>
                                        ) : (
                                            <Spinner></Spinner>
                                        )}
                                    </div>
                                    <div className="popup_footer">
                                        <div className="row">
                                            <div className="col-xs-12 col-md-12 col-lg-12 buttonFooter">
                                                <button className="btn btn-default btn-block" onClick={() => {
                                                    this.setState({
                                                        openPopup: false
                                                    })
                                                }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : null
                }
            </React.Fragment>
        );
    }
}

export default Transactions;